import type { MessageCatalog } from './entry';

/**
 * The words every dialog shares. A component reaches here first, and only
 * mints its own key when the string really is its own.
 */
export const common = {
  'common.close': { en: 'Close', nl: 'Sluiten' },
  'common.cancel': { en: 'Cancel', nl: 'Annuleren' },
  'common.save': { en: 'Save', nl: 'Opslaan' },
  'common.saving': { en: 'Saving…', nl: 'Opslaan…' },
  'common.working': { en: 'Working…', nl: 'Bezig…' },
  'common.sending': { en: 'Sending…', nl: 'Versturen…' },
  'common.loading': { en: 'Loading…', nl: 'Laden…' },
  'common.confirm': { en: 'Confirm', nl: 'Bevestigen' },
  'common.delete': { en: 'Delete', nl: 'Verwijderen' },
  'common.remove': { en: 'Remove', nl: 'Verwijderen' },
  'common.rename': { en: 'Rename', nl: 'Hernoemen' },
  'common.create': { en: 'Create', nl: 'Aanmaken' },
  'common.add': { en: 'Add', nl: 'Toevoegen' },
  'common.edit': { en: 'Edit', nl: 'Bewerken' },
  'common.undo': { en: 'Undo', nl: 'Ongedaan maken' },
  'common.done': { en: 'Done', nl: 'Klaar' },
  'common.back': { en: 'Back', nl: 'Terug' },
  'common.retry': { en: 'Try again', nl: 'Opnieuw proberen' },
  'common.dismiss': { en: 'Dismiss', nl: 'Sluiten' },
  'common.search': { en: 'Search', nl: 'Zoeken' },
  'common.name': { en: 'Name', nl: 'Naam' },
  'common.email': { en: 'Email', nl: 'E-mail' },
  'common.password': { en: 'Password', nl: 'Wachtwoord' },
  'common.role': { en: 'Role', nl: 'Rol' },
  'common.failed': { en: 'That did not work.', nl: 'Dat is niet gelukt.' },

  /* The three roles, wherever one is shown rather than stored. */
  'role.viewer': { en: 'viewer', nl: 'kijker' },
  'role.editor': { en: 'editor', nl: 'bewerker' },
  'role.admin': { en: 'admin', nl: 'beheerder' },
} as const satisfies MessageCatalog;
